import { defaultGapping, GSButton, GSInfoGroup } from "golfstatus_react_components";
import { usePermissions } from "../../hooks/permissionHooks";
import './registration-line-item.scss'

/**
 * View to display html.
 * 
 * @typedef Properties
 * @type {object}
 * 
 * @property {string} cheapestTeamPackageCost the html string to display
 * 
 * @property {object} style style for the component
 * 
 *
 * @param {Properties} props cheapestTeamPackageCost, style
 */


const RegistrationLineItem = (props) => {

  const {registrationAction, donationAction, style} = props;

  const permissions = usePermissions();

  const registrationActionSection = {
    type:"mobile-stretch",
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: <GSButton style={{flexGrow: 1}} {...registrationAction}/>,
      },
    ]
  }

  const donationActionSection = {
    type:"mobile-stretch",
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: <GSButton style={{flexGrow: 1}} {...donationAction}/>,
      },
    ]
  }

  const registrationActionColumn ={
    type:"mobile-stretch",
    sections: [
      registrationActionSection,
    ],
  }

  const donationActionColumn ={
    type:"mobile-stretch",
    sections: [
      donationActionSection,
    ],
  }

  const getGroup = () => {
    let group = []
    if (permissions?.packagesEnabled()) {
      group.push(registrationActionColumn)
    }
    if (permissions?.donationsActive()){
      group.push(donationActionColumn)
    }
    return group
  }

  return <registration-line-item style={style}>
    <GSInfoGroup listType="mobile-vertical" listStyle={{...defaultGapping.mediumLargeGap}} dataGroups={getGroup()}></GSInfoGroup>
  </registration-line-item>
}


export default RegistrationLineItem